/** Překročen maximální počet znaků: @0 */
export const MAX_LENGTH_ERROR_LOC_KEY = "GUI-716495";
/** Nevalidní hodnota v poli */
export const INVALID_CONTROL_VALUE_LOC_KEY = "GUI-214428";
/** Informuje o tom, že pole je povinné, ale nemá vyplněnu (platnou) hodnotu. Text: "Nevalidní hodnota v poli". */
export const REQUIRED_INVALID_STATE_LOC_KEY = "GUI-55627";

/** Minimální možná hodnota je */
export const MIN_VALUE_VALIDATION_ERROR_LOC_KEY = "GUI-502669";
/** Maximální možná hodnota je */
export const MAX_VALUE_VALIDATION_ERROR_LOC_KEY = "GUI-502667";
/** Minimální možná hodnota je @0 */
export const MIN_VALUE_VALIDATION_ERROR_ARGS_LOC_KEY = "GUI-754891";
/** Maximální možná hodnota je @0 */
export const MAX_VALUE_VALIDATION_ERROR_ARGS_LOC_KEY = "GUI-754892";
